module.exports = __webpack_public_path__ + "media/images/ic-remove-verde-060acd0e0d9cb6e88b11616f44305f2c.svg";